// src/components/InstallPrompt.js
// Shows iOS install instructions + handles Android beforeinstallprompt
import React, { useEffect, useState } from 'react'

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent)
}

function isInStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
}

export default function InstallPrompt() {
  const [show, setShow] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [isIos, setIsIos] = useState(false)

  useEffect(() => {
    // Don't show if already installed
    if (isInStandaloneMode()) return

    // Already dismissed this session
    if (sessionStorage.getItem('install-dismissed')) return

    setIsIos(isIOS())

    // Android / Chrome install prompt
    const handler = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setShow(true)
    }
    window.addEventListener('beforeinstallprompt', handler)

    // iOS — show after a short delay
    if (isIOS()) {
      setTimeout(() => setShow(true), 3000)
    }

    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const dismiss = () => {
    setShow(false)
    sessionStorage.setItem('install-dismissed', '1')
  }

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt()
      const { outcome } = await deferredPrompt.userChoice
      setDeferredPrompt(null)
    }
    dismiss()
  }

  if (!show) return null

  return (
    <div className="install-prompt">
      <div className="install-prompt-inner">
        <div className="install-prompt-icon">M</div>
        <div className="install-prompt-text">
          <div className="install-prompt-title">Add to Home Screen</div>
          {isIos ? (
            <div className="install-prompt-sub">
              Tap <strong>Share</strong> then <strong>"Add to Home Screen"</strong> for the full app experience
            </div>
          ) : (
            <div className="install-prompt-sub">
              Install The Magic for quick access from your home screen
            </div>
          )}
        </div>
        <div className="install-prompt-actions">
          {!isIos && (
            <button className="install-btn-primary" onClick={install}>Install</button>
          )}
          <button className="install-btn-dismiss" onClick={dismiss}>✕</button>
        </div>
      </div>
    </div>
  )
}
